import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProcessService } from 'src/app/service/process.service';
import swal from 'sweetalert2';
import { InstanceModel } from 'src/app/model/instance.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { AttributeModel } from '../../dynamic/model/attribute.model';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { AuthenticationService } from 'src/app/service/auth.service';
import { ProcessModel } from 'src/app/model/process.model';
import { DynamicEvent } from '../../dynamic/dynamic.event';

@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProcessComponent implements OnInit {

  processModel: ProcessModel;
  sections: AttributeModel[] = [];
  listAttribute: Array<string> = [];
  policies: Array<string> = [];
  policyName: string = '';
  parameter: any;
  currentStep: InstanceModel

  id: number;
  private sub: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processService: ProcessService,
    private spinner: NgxSpinnerService,
    private sharedData: SharedDataService,
    private authService: AuthenticationService) {
    this.route.params.subscribe(params => this.parameter = params);
  }

  ngOnInit() {
    this.spinner.show();

    if (this.loadParams()) {
      sessionStorage.removeItem('stepCurrent');

      this.processService.load(this.sections)
        .subscribe((processModel: ProcessModel) => {
          this.loadAttributes(processModel)
          this.currentStep = this.processService.currentStep
          this.processService.notifyLoaded()
          this.spinner.hide();
        }, (error) => this.handleHttpError(error))
    }
    else {
      swal.fire('Atenção!', 'Erro ao carregar a tela.', 'info');
      let botao = swal.getConfirmButton();
      botao.addEventListener('click', this.navigateToDashboard.bind(this));
    }
  }

  private loadParams(): boolean {
    if (this.parameter.mode) {
      sessionStorage.setItem('typeDynamic', this.parameter.mode);
    } else {
      sessionStorage.removeItem("typeDynamic");
      return false;
    }

    if (this.parameter.policy) {
      sessionStorage.setItem('idPolicy', this.parameter.policy);
    } else {
      sessionStorage.removeItem("idPolicy");
      return false;
    }

    if (this.parameter.process) {
      sessionStorage.setItem('processId', this.parameter.process);
    } else {
      sessionStorage.removeItem("processId");
    }

    return true;
  }

  navigateToDashboard() {
    this.router.navigateByUrl('/dashboard');
  }

  private loadAttributes(processModel: ProcessModel) {
    this.processModel = processModel;
    this.policyName = this.processModel.policyName;

    this.sharedData.resetCategory("items")

    this.sections.forEach(element => {
      this.listAttribute.push(element.key);
    });

    if(this.sections[0]) {
      sessionStorage.setItem('stepCurrent', this.sections[0].key);
    }

    sessionStorage.setItem('policies', JSON.stringify(this.sections));
    sessionStorage.setItem('listAttribute', JSON.stringify(this.listAttribute));
    sessionStorage.setItem('policySteps', JSON.stringify(this.processModel.instance));
    sessionStorage.setItem('policyVersionId', this.processModel.policyVersionId);
  }

  private handleHttpError(error: any) {
    this.spinner.hide();

    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }

  onSectionEmit(events: DynamicEvent[]) {
    events.forEach(event => {
      if(event.name == "save and update" || event.name == "update") {
        let newSections: AttributeModel[] = []
        this.processService.load(newSections)
          .subscribe(() => {
            this.currentStep = this.processService.currentStep
            this.sections = newSections
            this.spinner.hide();
          }, (error) => this.handleHttpError(error))
      }
    })
  }

  trackByFn(index: number, item: AttributeModel): string {
    return item.key
  }
}
